import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Box, H2 } from '@vp/swan';
import { Tooltip } from '../../../@core/components/ui/tooltip/Tooltip.js';
import { useReplacementFeatureStore } from '../stores/index.js';
import { contentMapping } from '../configs/Content.mapping.js';
import { useMainContext } from '../../../contexts/MainContext.js';

const Content=()=>{const{t}=useMainContext();const{currentStep}=useReplacementFeatureStore();const step=contentMapping[currentStep];return jsxs(Box,{"data-cy":"replacement-content-container",children:[jsxs(Box,{className:"content-body-title-container",mt:"7",display:"flex",children:[jsx(H2,{"data-cy":"replacement-content-step-title",className:"step-title",fontSkin:"title-section",children:t(step.title)}),!!step.titleInfo&&jsx(Tooltip,{"data-cy":"replacement-content-step-titleinfo",popupMl:3,content:t(step.titleInfo)})]}),jsx(Box,{"data-cy":"replacement-content-step-content",mt:6,mb:6,children:contentMapping[currentStep].content})]})};

export { Content };
//# sourceMappingURL=Content.js.map
